import { FILE_NAME_EDGE_DASHES, FILE_NAME_UNSAFE_CHARACTERS } from "./constants";

const pad = (value: number) => String(value).padStart(2, "0");

/** `fs-retrieval-failures-{integrator or skin}[-{game}]-{local date}.csv` */
export const getFailedGamesFileName = (targetName: string, date: Date): string => {
  const slug = targetName
    .toLowerCase()
    .replace(FILE_NAME_UNSAFE_CHARACTERS, "-")
    .replace(FILE_NAME_EDGE_DASHES, "");
  // Local date: `toISOString` is UTC.
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `fs-retrieval-failures-${slug}-${day}.csv`;
};
